export interface OilEntry {
  id: string;
  time: string;
  location: string;
  bunkerTakenUsg: string;
  costPerUsgAfterTaxUsd: string;
  costUsd: string;
  costLocalCurrency: string;
  totalOnboardUsg: string;
}

export interface OilLogState {
  date: string;
  entries: OilEntry[];
}

// Entry times are captured as HH:MM (00:00–23:59) and merged with the log's
// selected date into a full ISO `date_time` for the backend.
export const TIME_RE = /^([01]\d|2[0-3]):([0-5]\d)$/;
